import React, { useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddSupplierModal(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const {shipTotal, setShipTotal} = props;
	const [shipping, setShipping] = useState(0);

	const handleOpen = () => {
		setShipping(shipTotal);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		handleClose();
	}
	
	const saveShipping = () => {
		setShipTotal(shipping);
	}

	return (
		<div>
			<Button style={{minWidth: "190px", marginBottom:"0.5em", marginRight:"0.5em"}} variant="outlined" color="primary" onClick={handleOpen}>
				Update Shipping Fee
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h4 style={{marginBottom : "35px"}}id="transition-modal-title">Update Shipping Fee</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={3}>
									Shipping Fee
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Shipping fee"
										variant="outlined"
										type="number"
										InputProps={{ inputProps: { min: 0 } }}
										value={shipping}
										onKeyPress={(e) => { 
											if(e.key == '-'){
												e.preventDefault();
											}
										 }}
										onChange={e => {
											setShipping(e.target.value);
										}}
										onBlur={(e) => {
											if(parseFloat(e.target.value) > 0){
												setShipping(e.target.value);
											}else{
												setShipping(0);
											}
											//console.log(e.target.value);
										}}
									/>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button type="submit" 
									onClick={()=>{saveShipping()}} 
									variant="contained" 
									color="primary"
									style={{backgroundColor: "#4caf50", color:"#fff"}}
								>
									Save
								</Button>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
